import { Outlet } from "react-router-dom";

/**
 * Chromeless layout for authentication (login): NO header, NO sidebar — the
 * form stands alone on a full-page nature watermark, per design proposal
 * ("le formulaire doit être seul sans side bar, un bg nature en filigrane vert").
 */
export function AuthLayout() {
  return (
    <div className="nbs-auth">
      <div className="nbs-auth__veil" aria-hidden="true" />
      <Outlet />
    </div>
  );
}
